import React from "react";
import "./singleNotification.scss";
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../ScreenSizeContext";

const SingleNotification = ({
  id,
  id_event, //serve per capire nel backend su quale tabella basarci
  image_type,
  image,
  title,
  body,
  datetime_sending,
  displayed,
  question,
  handleClick = null,
}) => {
  const navigate = useNavigate();
  const isPC = useScreenSize();

  const styleMobile = {
    backgroundColor: !displayed ? "rgba(96, 138, 189, 0.22)" : "#f8f8f8",
  };
  const stylePC = { backgroundColor: !displayed ? "#D4EDFF" : "#E1E1E1" };

  return (
    <div
      className="single-notification"
      style={isPC ? stylePC : styleMobile}
      onClick={() => {
        handleClick
          ? handleClick({ id, id_event, question })
          : navigate(
              `/notifications/${id}?id_event=${id_event ?? 0}&question=${
                question ?? 0
              }`
            );
      }}
    >
      <div className="content-notification">
        <img
          className="image-association"
          src={
            image ? "data:" + image_type + ";base64," + image : "/no_img.png"
          }
          alt="Associazione"
        />
        <div className="text-notification">
          <div className="title">{title}</div>
          <div className="paragraph">{body}</div>
        </div>
        <div className="right-click">
          <span className="lnr lnr-arrow-right"></span>
        </div>
      </div>
      <div className="datetime-notification">{datetime_sending}</div>
    </div>
  );
};

export default SingleNotification;
